import React, { useState, useEffect, useRef } from 'react';
import { Button } from 'primereact/button';
import {Icones} from './FontConfig'


export default function DeleteButton (props){
    return <Button 
                {...props}
                icon= {Icones.Excluir}
                />
}